<template>
  <div class="login-container">
    <img :src="platformLogos.tradique" width="100" height="100" />
    <h1 class="title my-5">Log into Tradique</h1>
    <form
      class="login-form-container"
      method="POST"
      :action="urls.login"
      ref="formRef"
    >
      <field-input
        v-model="email"
        ref="emailRef"
        id="login_input"
        type="email"
        name="login"
        class="mb-4"
        label="Email"
        :server-error="serverError.login"
        isEN
        :rules="[
          vRules.required('Please enter your Email address.'),
          vRules.email('Email is not valid.'),
        ]"
      />
      <field-input
        v-model="password"
        ref="passwordRef"
        id="password_input"
        type="password"
        class="mb-4"
        name="password"
        label="Password"
        input-class="ltr"
        isEN
        :server-error="serverError.password"
        :rules="[vRules.required('Please enter your password.')]"
      />

      <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
      <input
        v-if="redirectFieldValue"
        type="hidden"
        :name="redirectFieldName"
        :value="redirectFieldValue"
      />

      <div
        v-if="serverError.nonFieldErrors"
        class="mt-0 error-text text-center mb-4"
      >
        {{ serverError.nonFieldErrors }}
      </div>
      <button
        type="submit"
        class="btn tradique-primary-btn w-100"
        :disabled="isLoading"
      >
        Sign In
      </button>
    </form>
  </div>
</template>

<script>
import FieldInput from "~/components/FieldInput.vue";

export default {
  components: { FieldInput },
  data: () => ({
    isLoading: false,
    ...serverData,
    platformLogos,
  }),
  mounted() {
    if (this.autoSocialLogin) {
      this.$refs.passwordRef.focus();
    } else {
      this.$refs.emailRef.focus();
    }
    this.$refs.formRef.addEventListener("submit", (e) => {
      this.isLoading = true;
      const email_validation = this.$refs.emailRef.validate();
      const password_validation = this.$refs.passwordRef.validate();
      if (!email_validation || !password_validation) {
        e.preventDefault();
        this.isLoading = false;
      }
    });
  },
};
</script>

<style lang="scss">
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .title {
    color: #6e47ff;
  }
}
.login-form-container {
  max-width: 360px;
  width: 100%;
  padding: 1rem;
  text-align: left;
  color: #17006e;
}

.tradique-primary-btn {
  background-color: #17006e;
  color: #fff;

  &:hover {
    background-color: #6e47ff;
    color: #fff;
  }
}
</style>
